<template lang="html">
    <div id="account">
        <header>
            Privacy settings
            <router-link :to="{ name: 'Account' }"
                ><chevron-left-icon class="icon"></chevron-left-icon
            ></router-link>
        </header>

        <form class="form privacy">
            <div class="formGroup">
                <p class="help">
                    Receive information about your account, notifications from the app and messages
                    from Lesson Pro:
                </p>
            </div>
            <div class="formGroup b">
                <label class="highlight">Email</label>

                <toggle-switch
                    name="email"
                    @input="savePrivacy"
                    v-model="form.notification_email"
                />
            </div>
            <div class="formGroup b">
                <label class="highlight">Text</label>
                <toggle-switch name="text" @input="savePrivacy" v-model="form.notification_text" />
            </div>

            <div class="formGroup b">
                <label class="highlight">Push notification</label>
                <toggle-switch name="push" @input="savePrivacy" v-model="form.notification_push" />
            </div>

            <div class="formGroup b">
                To view our Privacy Policy in full
                <a
                    @click.prevent="openExternalTab('https://lessonpro.co.uk/privacy')"
                    style="color: white"
                    target="_blank"
                    href=""
                    >click here</a
                >
            </div>
        </form>
    </div>
</template>

<script>
import { Form } from "vform";
import ToggleSwitch from "@/components/App/toggle-switch.vue";
import { ChevronLeftIcon } from "vue-feather-icons";
export default {
    name: "privacy",
    components: { ToggleSwitch, ChevronLeftIcon },
    data() {
        return {
            oWebViewInterface: window.nsWebViewInterface,
            form: new Form({
                notification_email: 1,
                notification_text: 1,
                notification_push: 1,
            }),
        };
    },
    mounted() {
        if (this.$store.state.user.settings) {
            this.form.fill(this.$store.state.user.settings);
        }
    },
    methods: {
        openExternalTab(url) {
            this.oWebViewInterface.emit("openExternalTab", url);
        },
        savePrivacy() {
            this.form.post("/settings").then((settings) => {
                this.$store.dispatch("updateUserSettings", settings.data);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.privacy {
    .switch {
        position: absolute;
        right: 0px;
        top: 12px;
    }
    .formGroup {
        margin-bottom: 30px;
    }
}
</style>
